<template>
   <PreviewFile
        v-if="urlImageUploaded"
        :srcImageUploaded="urlImageUploaded"
        :chooseAnotherFile="chooseAnotherFile"
        :confirmUploadFile="confirmUploadFile"
   />
</template>
<script>
import axios from 'axios';
import { useStore } from '../../../stores/cadastro.js';
import { useRouter } from 'vue-router';
import PreviewFile from '../../components/PreviewFile.vue'

export default {
    components: {
        PreviewFile
    },
    setup() {
        const router = useRouter();
        const store = useStore();
        
        return {
            router,
            store
        }
        },
        data() {
            return {
                urlImageUploaded: '',
                routeName: '',
                textCard: '',
                nextRoute: '',
                isFirstUpload: true,
                file: null
            };
    },
    mounted() {
        this.urlImageUploaded = this.$route.query.urlImageUploaded;
        this.routeName = this.$route.query.routeName;
        this.textCard = this.$route.query.textCard;
        this.nextRoute = this.$route.query.nextRoute;
        this.file = history.state.file

        const vehicle_file = this.store.getVehicleFile[this.routeName]

        if (vehicle_file && !vehicle_file.isFirstUpload) {
            this.isFirstUpload = false
        }
               
    },
    methods: {
        chooseAnotherFile() {
            if(this.routeName == 'vehicle_front') {
                this.router.push({ name: 'VehicleFront', query: { currentStep: 2} })
            }else {
                this.router.back();
            }
        },
        async confirmUploadFile() {
            if (this.routeName != 'SavedVehicleFiles') {

                const objectName = this.routeName;
                const cardName = this.textCard;
                const fileName = this.file.name;

                const fileParts = fileName.split('.');
                const fileExtension = fileParts.pop();

                const driverId = this.store.driverId;

                const isFirstUpload = this.isFirstUpload


                this.isLoading = true;
                const url = `/_api_proxy/drivers-v2/drivers/${driverId}/images/${this.routeName}.${fileExtension}`;

                this.store.vehicleFiles[objectName] = {
                    cardName: cardName,
                    routeNameComponent: objectName,
                    fileName: fileName,
                    isFirstUpload: isFirstUpload,
                    statusUpload: 'Loading'
                };

                try {
                    const response = await axios.post(url, this.file);
                    if ( response.status = 200 ) {
                        this.store.updateVehicleFileStatus(objectName, 'Success');
                    }
                } catch (error) {
                    this.store.updateVehicleFileStatus(objectName, 'Error');
                } finally {
                    this.isLoading = false; 
                }   
            }

            if (this.isFirstUpload == false) {
                this.nextRoute = 'SavedVehicleFiles'
            }
            this.router.push({name: this.nextRoute})
        }
    }
}
</script>
 